import api from "./axios";

export async function getCommentary(orderId) {
  const response = await api.get(`/ordercoms/${orderId}`);
  return response;
}

export async function postCommentary(commentary) {
  const response = await api.post("/ordercoms", commentary);
  return response;
}

export async function deleteCommentary(commentaryId) {
  const response = await api.delete(`/ordercoms/${commentaryId}`);
  return response;
}

export async function putCommentary(commentary, commentaryId) {
  const response = await api.put(`/ordercoms/${commentaryId}`, commentary);
  return response;
}
